module.exports = __webpack_public_path__ + "images/Drag Icon_Blue.svg";